import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  referringContact: null,
  emergencyContacts: [],
};

export const contactInfoSlice = createSlice({
  name: 'contactInfo',
  initialState: initialState,
  reducers: {
    clearContactInfo: () => {
      return initialState;
    },

    setReferringContact: (state, action) => {
      return { ...state, referringContact: action.payload };
    },

    clearReferringContact: (state) => {
      return { ...state, referringContact: null };
    },

    addEmergencyContact: (state, action) => {
      const extendedList = [...state.emergencyContacts, action.payload];
      return { ...state, emergencyContacts: extendedList };
    },

    removeEmergencyContact: (state, action) => {
      const index = action.payload;
      const before = state.emergencyContacts.slice(0, index);
      const after = state.emergencyContacts.slice(index + 1);
      const shorterList = before.concat(after);
      return { ...state, emergencyContacts: shorterList };
    },

    clearEmergencyContacts: (state) => {
      return { ...state, emergencyContacts: [] };
    },
  },
});

export const {
  clearContactInfo,
  setReferringContact,
  clearReferringContact,
  addEmergencyContact,
  removeEmergencyContact,
  clearEmergencyContacts,
} = contactInfoSlice.actions;

export default contactInfoSlice.reducer;
